import axios from "axios";
import { Email, TypeEmail } from "../../Models/Email/EmailModels";
import { errorService } from "../Error/ErrorService";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { TypeEmailService } from "./TypeEmailService";

export function EmailService(){
    return{
        async getEmail(id:number, token:string):Promise<Email>{
            try {
                const response = await axios.get(`${URLAPI+'email/'+id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                // console.log('data email: ', data);
                let email : Email = {
                    id: 0,
                    email: "",
                    typeEmail: undefined,
                    actif: false
                };
                if(data.length>0){
                    email = {
                        id: data[0]['id'],
                        email: data[0]['email'],
                        typeEmail: data[0]['typeEmail'] ? await TypeEmailService().getTypeEmailFromUrlToPromiseToEmail(data[0]['typeEmail'], token):undefined,//temporaire
                        actif: data[0]['actif'],
                    }
                    return email;
                }
                return email;
            } catch (error) {
                errorService().handleError('Erreur lors du getMagasin', error)
                let email : Email = {
                    id: 0,
                    email: "",
                    typeEmail: undefined,
                    actif: false
                };
            
                return email;
            }
        },

        async getEmailsFromUrlsToTypeEmail(urls:string[], token:string):Promise<Email[]>{
            let emails:Email[]=[];
            for(const url of urls){
                try {
                    const response = await axios.get(`${URL_MIDIS+url}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":"application/ld+json"
                        },
                    });
                    const data = response.data['hydra:member'];
                    if(data.length>0){
                        emails.push({
                            id: data[0]['id'],
                            email: data[0]['email'],
                            actif: data[0]['actif'],
                        });
                    }
                } catch (error) {
                    errorService().handleError('Erreur lors du getEmailsFromUrlsToMagasin', error)
                    return [];
                }
            }
            return emails;
        },

        //Création du tableau de magasins suite aux données obtenues dans l'api
        async getEmailsFromUrlsToMagasin(urls:string[], token:string):Promise<Email[]>{
            let emails:Email[]=[];
            for(const url of urls){
                try {
                    const response = await axios.get(`${URL_MIDIS+url}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":"application/ld+json"
                        },
                    });
                    const data = response.data['hydra:member'];
                    if(data.length>0){
                        const [typeEmail] = await Promise.all([
                            TypeEmailService().getTypeEmailFromUrlToPromiseToEmail(data[0]['typeEmail'], token)
                        ]);
                        emails.push({
                            id: data[0]['id'],
                            email: data[0]['email'],
                            typeEmail: typeEmail,
                            actif: data[0]['actif'],
                        });
                    }
                } catch (error) {
                    errorService().handleError('Erreur lors du getEmailsFromUrlsToMagasin', error)
                    return [];
                }
            }
            return emails;
        },
    
        /**
         * Cette méthode permet de transformer un email, rataché à un magasin, via une URL, en un objet Email.
         * Pour éviter toute boucle infini via la relation entre un email et son/ses magasin(s),
         * il est préférable de ne pas enregistré la valeur lié au magasin, ni de la transformer en objet Magasin. 
         * Donc celle-ci restera un objet Magasin|undefined, qui ici sera undefined. (Modification possible à l'avenir).
         * 
         * Si vous souhaitez accèder au client à partir de l'objet magasin, alors employez la méthode ???
         */
        async getEmailFromUrlToPromise(url:string, token:string):Promise<Email>{
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let email : Email = {
                    id: data[0]['id'],
                    email: data[0]['email'],
                    typeEmail: data[0]['typeEmail'] ? await TypeEmailService().getTypeEmailFromUrlToPromiseToEmail(data[0]['typeEmail'], token):undefined,//temporaire
                    actif: data[0]['actif'],
                };
                
                return email;
            } catch (error) {
                errorService().handleError('Erreur lors du getEmailFromUrlToPromise', error)
                let email : Email = {
                    id: 0,
                    email: "",
                    typeEmail: undefined,
                    actif: false
                };
            
                return email;
            }
        },

        async postNewAdresseContact(token:any, idMagasin:number, adresse:string, typeEmail:TypeEmail){
            const postEmailObject = {"email":adresse, "magasins":[idMagasin], "typeEmail":typeEmail.id}
            const responsePOSTEmail = await axios.post(
                `${URLAPI+'email'}`,
                postEmailObject,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/ld+json',
                    },
                }
            );
            return {
                status:responsePOSTEmail.status,
                idEmail:responsePOSTEmail.data['id']
            };
        },

        async postEmailTypeEmailMIDISAdmin(idTypeEmail:number, adresse:string, token:string){
            try {
                const postEmailObject = {"email":adresse, "magasins":[], "typeEmail":idTypeEmail};

                const responsePOSTEmail = await axios.post(
                    `${URLAPI+'email'}`,
                    postEmailObject,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return responsePOSTEmail.status;
            } catch (error) {
                errorService().handleError('Erreur ajout mail',error);
                return 400;
            }
        },

        async patchAdresseContact(adresse:string, idEmail:number|undefined, idMagasin:number|undefined, typeEmail:TypeEmail, token:any){
            if(!idMagasin || !idEmail){
                throw new Error("Id du magasin ou de l'email non défini");
            }
            let patchEmailObject = {"email":adresse, "magasins":[idMagasin], "typeEmail":typeEmail.id};

            const responsePATCHemail = await axios.patch(
                `${URLAPI+'email/'+idEmail}`,
                patchEmailObject,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return responsePATCHemail.status;
        },

        async patchEmailTypeEmailMIDISAdmin(idEmail:number, adresse:string, token:string){
            try {
                const patchEmailObject = {"email":adresse};

                const responsePOSTEmail = await axios.patch(
                    `${URLAPI+'email/'+idEmail}`,
                    patchEmailObject,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                return responsePOSTEmail.status;
            } catch (error) {
                errorService().handleError('Erreur modification mail',error);
                return 400;
            }
        },

        async deleteAdresseContact(id:number, token:any){
            const response = await axios.delete(
                `${URLAPI}email/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.status;
        }
    }
}